
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DataOptions } from 'vuetify';
import { UnapprovedPO } from '@/models/unapprovedPO';
import { CurrencyHelper } from '@/helpers/CurrencyHelper';

@Component
export default class PODataTable extends Vue {
  @Prop({ type: Array, required: true }) readonly headers!: object[];
  @Prop({ type: Array, default: () => [] }) readonly items!: UnapprovedPO[];
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Object, required: true }) readonly options!: DataOptions;
  @Prop({ type: Number, default: 0 }) readonly totalItems!: number;
  get tableOptions(): DataOptions {
    return this.options;
  }

  set tableOptions(value: DataOptions) {
    this.$emit('update:options', value);
  }

  formatCurrency(value: number, currencyCode?: string | null): string {
    if (currencyCode) {
      return CurrencyHelper.formatCurrencyWithCode(value, currencyCode);
    }
    return CurrencyHelper.formatCurrency(value);
  }

  formatDate(value: string): string {
    if (!value) return '';
    return new Date(value).toLocaleDateString();
  }

  viewDetails(item: UnapprovedPO) {
    this.$emit('view-details', item);
  }
}
